import * as React from 'react';
const CustomDnbCritical = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" {...props}>
    <g data-name="Layer 2">
      <path
        fill="#ff5400"
        fillRule="evenodd"
        d="M7 14a7 7 0 1 0-7-7 7 7 0 0 0 7 7m3.35-3.65a.48.48 0 0 1-.7 0L7 7.71l-2.65 2.64a.49.49 0 0 1-.7-.7L6.29 7 3.65 4.35a.49.49 0 0 1 .7-.7L7 6.29l2.65-2.64a.49.49 0 0 1 .7.7L7.71 7l2.64 2.65a.48.48 0 0 1 0 .7"
        data-name="Layer 1"
      />
    </g>
  </svg>
);
export default CustomDnbCritical;
